<template>
  <div v-if="visible" class="modal-backdrop-wrapper">
    <div class="modal d-block" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content border border-primary">
          <div class="modal-header border border-primary">
            <h5 class="modal-title">
              
               <i v-if="icon"
                  :class="['fas', iconClass,'mr-3']"
                  :style="{ fontSize: '20px', color: iconColor }">
              </i>
              
              {{ title }}</h5>
          </div>
          <div class="modal-body">
            <div v-if="spinner" class="text-center mb-2">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            
                  <div style="white-space: pre-line;font-size: larger;"  v-if="message" >
               
             {{ message }}
              </div>

             <!--<div class="modal-confirm" v-if="message" v-html="message"></div>-->
          </div>
          <div class="modal-footer">

            <button :disabled="spinner" @click="cancel" class="btn btn-secondary">
                ANNULLA
            </button>

            <button v-if="!spinner" class="btn btn-primary" @click="confirm">
                OK
            </button>
         
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
 
  data() {
    return {
      visible    : false,
      message    : '',
      title      : 'ATTENZIONE',
      spinner    : false,
      icon       : ''
    }
  },

  
computed: {
  
  iconClass() {
    const map = {
     
      1: 'fas fa-question-circle',
      2: 'fa-exclamation',
      3: 'fa-exclamation-triangle',
     
    }

    return map[this.icon] || ''
  },

  iconColor() {
    const colors = {
      1: 'blue',
      2: 'blue',
      3: 'red',
     
    }

    return colors[this.icon] || 'blue'
  }
  },

  methods: {

show(msg = '', options = {},icon='') {
  this.message  = msg
  this.title    = options.title || 'ATTENZIONE'
  this.spinner  = options.spinner || false
  this.visible  = true
  this.icon     = icon

  return new Promise(resolve => {
    this._resolver = resolve
  })
},


// Non chiude subito
confirm() {
  // Risolve il valore true, ma lascia la modal aperta
  if (this._resolver) this._resolver(true)
  // Non chiudere ancora, useremo setSpinner per rimanere visibile
}
/*
confirm() {
  this.visible = false
  if (this._resolver) this._resolver(true)
},
*/
,
cancel() {
  this.visible = false
  if (this._resolver) this._resolver(false)
},


/*

    show(msg = '', options = {}) {
      this.message = msg
      this.title = options.title || 'ATTENZIONE'
      this.spinner = options.spinner || false
      this.visible = true

      return new Promise(resolve => {
        const unwatch = this.$watch('visible', val => {
          if (!val) {
            unwatch()
            resolve()
          }
        })
      })
    },
    */
    close() {
      this.visible = false
      this.message = ''
      this.spinner = false
    },
    setSpinner(val,msg = '', options = {}) {
      this.message  = msg
      this.title    = options.title || 'REGISTRAZIONE IN CORSO ...'
      this.spinner = val
    }
  }
}
</script>

<style scoped>
.modal-backdrop-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1050; /* sopra tutto */
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.5); /* backdrop semi-trasparente */
}

.modal.d-block {
  display: block;
  z-index: 1060; /* sopra il backdrop */
}
.modal-confirm {
  white-space: pre-line;
}
</style>